const Genesis = require("../Genesis.js");
import 'jquery-ui';
import { DocumentTree } from './DocumentTree';

interface IName {
    name: string;
}

interface ITreeUserPermissions {
    canAddLibrary: boolean,
    canCopyDocument: boolean,
    canDeleteLibrary: boolean,
    canRenameLibrary: boolean,
    canMoveLibrary: boolean,
    canAddNewDocument: boolean,
    canCheckOutDocument: boolean,
    canSetPermissionsForLibrary: boolean,
    canReplaceDocument: boolean,
    canRemoveCheckInLock: boolean,
    canAddLinks: boolean,
    canEditLinks: boolean
}

interface ITreeSelectors {
    containerSelector: string,
    libraryTreeSelector: string,
    menuSelector: string
}

type ILibraryTreeSource = () => JQueryXHR;

export class LibraryTreeManager {
    private Tree: DocumentTree = new DocumentTree();

    constructor(private libraryGridName: string, private recordTypeId: number, private showCheckboxes: boolean = true, private checkChildren = false) {             
    }
    
    public init(): any {
        const permissions: ITreeUserPermissions = {
            canAddLibrary: false,
            canCopyDocument: false,
            canDeleteLibrary: false,
            canRenameLibrary: false,
            canMoveLibrary: false,
            canAddNewDocument: false,
            canCheckOutDocument: false,
            canSetPermissionsForLibrary: false,
            canReplaceDocument: false,
            canRemoveCheckInLock: false,
            canAddLinks: false,
            canEditLinks: false
        };
    
        const selectors: ITreeSelectors = {
            containerSelector: "#uploadDocumentToLibraryModal",
            libraryTreeSelector: this.libraryGridName,
            menuSelector: ""
        }

        let self = this;
        const libraryTreeSource: ILibraryTreeSource =
            function () {
                const promise =
                    $.ajax({
                        cache: false,
                        url: Genesis.url("Document/_GetLibrariesForRecordType"),
                        type: 'GET',
                        data: { recordTypeId: self.recordTypeId },
                        dataType: 'json'
                    });
                return promise;
            }        
        
        return this.Tree.init(permissions, false, selectors, this.showCheckboxes, this.checkChildren, false, libraryTreeSource, null, false);
    }
    public GetSelectedLibraries(): any[] {
        return this.Tree.getCheckedNodeIds();
    }

    public SetSelectedLibraries(libraryIds: Array<number>): void {
        $(this.libraryGridName + " input[type=checkbox]").each(
            function () {
                if ($(this).prop("checked")) {
                    $(this).click();
                }                
            });

        libraryIds.forEach((l) => {
            this.Tree.selectLibrary(l, true);
        });
    }

    public GetSelectedLibraryId(): number {
        return this.Tree.getSelectedLibraryId();
    }

    public GetSelectedLibraryPath(): string {
  
        if (this.Tree && this.Tree.getSelectedLibraryId() != null) {
            const selectionPath = this.Tree.getSelectionPath();
            if (selectionPath)
                return selectionPath.map(s=>s.fields["name"] as string).reduce((a: string, v: string) => a + "/" + v);
        }
        return "";
    }

    public GetCheckLibrariesPaths(): string {        
        const paths = this.Tree.getCheckedNodePaths();
        if (paths && paths.length) {
            return paths.join(",");            
        }
        else {
            return "";
        }        
    }

    public SelectLibrary(libraryId: number, check = false): void {
        if (libraryId) {
            this.Tree.selectLibrary(libraryId, check);
        }
    }
}

export function GetLibraryTreeManager(libraryGridName: string, recordTypeId: number, showCheckBoxes = false): LibraryTreeManager {
    return new LibraryTreeManager(libraryGridName, recordTypeId, showCheckBoxes);
}